import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import { DESIGN_PARTNER_PATHS } from "./routes";
import type { DesignPartnerTheme } from "./theme";

type Props = {
  theme: DesignPartnerTheme;
  onToggleTheme: () => void;
};

export function DesignPartnerNav({ theme, onToggleTheme }: Props) {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header>
      <div className="wrap nav">
        <Link to={DESIGN_PARTNER_PATHS.home} className="brand" onClick={closeMenu}>
          <span className="mark" aria-hidden="true" />
          Zephix
        </Link>
        <nav
          className={menuOpen ? "links mobileOpen" : "links"}
          aria-label="Main navigation"
          data-testid="dp-nav-links"
        >
          <NavLink to={DESIGN_PARTNER_PATHS.howItWorks} onClick={closeMenu}>
            How it works
          </NavLink>
          <NavLink to={DESIGN_PARTNER_PATHS.product} onClick={closeMenu}>
            Product
          </NavLink>
          <NavLink to={DESIGN_PARTNER_PATHS.roadmap} onClick={closeMenu}>
            Roadmap
          </NavLink>
          <NavLink to={DESIGN_PARTNER_PATHS.faq} onClick={closeMenu}>
            FAQ
          </NavLink>
        </nav>
        <div className="actions">
          <button
            type="button"
            className="theme"
            onClick={onToggleTheme}
            aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
            data-testid="dp-theme-toggle"
          >
            ◐
          </button>
          <Link
            className="btn primary navCta"
            to={DESIGN_PARTNER_PATHS.apply}
            onClick={closeMenu}
            data-testid="dp-nav-cta"
          >
            Request a conversation
          </Link>
          <button
            type="button"
            className="hamburger"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            data-testid="dp-hamburger"
          >
            ☰
          </button>
        </div>
      </div>
    </header>
  );
}
